import Cookies from 'js-cookie';
import { localeMap } from './constants';

export const scriptRunner = (event) => {
  if (event.target.nodeName === 'SCRIPT' && event.target.src.includes('FeedbackButtonModule')) {
    window.QSI.API.run();
  }
};

export const scriptChecker = () => {
  const body = document.querySelector('body');
  body.addEventListener('load', scriptRunner, true);
};

export const extendOnTrackCall = (correlationId) => (event) => {
  // If the event is what you expect, add the following meta value
  if (event.type === 'impression') {
    return { correlationId, meta: { correlationId } };
  }
  // Add nothing.
  return {};
};

export const dateToISOWithOffset = (time, offset) => {
  // format should be 2021-01-08T20:55:29.362-0700

  const absOffset = Math.abs(offset);
  const offsetString = `${offset > 0 ? '-' : '+'}${(absOffset / 60).toFixed(0).padStart(2, '0')}${(absOffset % 60).toString().padStart(2, '0')}`;
  return `${new Date(time - (offset * 60 * 1000)).toISOString().slice(0, 23)}${offsetString}`;
};

export const treatments = {
  fetch(idObj, action, state) {
    const {
      channelIdentifier = 'WEB',
      clientIdentifier = 'AcctSummary',
      componentIdentifiers = [],
      locale,
      loyaltyAccount = '',
      loyaltyTier = '',
      selectedProduct = '',
      treatmentFilters = {},
      viewIdentifier = '',
    } = idObj;

    const publicGuid = Cookies.get('blueboxpublic') || false;
    const now = new Date();
    const body = {
      global_request: {
        client_identifier: clientIdentifier,
        channel_identifier: channelIdentifier,
        view_identifier: viewIdentifier,
        locale,
        request_timestamp: dateToISOWithOffset(now.getTime(), now.getTimezoneOffset()),
        request_identifier: `${now.getTime()}`,
      },
      user_identification: {
        public_guid: publicGuid,
        card_objects: [{
          unique_card_identifier: selectedProduct,
          ...loyaltyAccount ? { loyalty_number: loyaltyAccount } : {},
          ...loyaltyTier ? { loyalty_tier_code: loyaltyTier } : {},
        }],
      },
      treatment_request_parameters: {
        treatment_filters: {
          domains: ['Card'],
          component_identifiers: componentIdentifiers,
          ...treatmentFilters,
        },
      },
    };
    const pznUrl = state.getIn(['config', 'pznApiUrl']);
    return {
      url: `${pznUrl}/v1/customers/treatments/decisions`,
      opts: {
        credentials: 'include',
        method: 'POST',
        body: JSON.stringify(body),
      },
    };
  },
};

export const normalizeFace = (face) => face && (Array.isArray(face) ? face[0] : face);

export const localeMapper = (locale) => {
  const cookieLocale = Cookies.get('axplocale');

  if (cookieLocale && cookieLocale.startsWith(locale)) {
    return cookieLocale.toLowerCase();
  }

  const mappedLocale = localeMap[locale] || locale;

  return mappedLocale && mappedLocale.replace('_', '-').toLowerCase();
};

export const setCookie = ({
  cookie, res, hostname, disableCookieURIEncoding,
}) => {
  const { key, value: valueRaw, ...cookieOptions } = cookie.toJSON();

  const value = decodeURIComponent(valueRaw);
  const cookieDomain = cookieOptions.domain;
  if (
    cookieDomain
    && `.${cookieDomain}`.endsWith(`.${hostname.split('.').slice(-2).join('.')}`)
  ) {
    const expressCookieOptions = {
      ...disableCookieURIEncoding ? { encode: String } : undefined,
      ...cookieOptions,
      ...cookieOptions?.maxAge && { maxAge: cookieOptions.maxAge * 1e3 },
    };

    res.cookie(key, value, expressCookieOptions);
  }
};

export const getLogoutUrl = () => {
  if (typeof window === 'undefined') return '';

  const url = new URL(window.location.href);
  const segments = url.pathname.split('/').filter(Boolean);
  if (segments.length > 0 && /^[a-z]{2}-[a-z]{2}$/i.test(segments[0])) {
    url.pathname = `/${segments[0]}/account/logout`;
  } else {
    url.pathname = '/account/logout';
  }
  url.search = '';
  url.hash = '';

  return url.toString();
};
